import { useState } from "react";
import { Form, Dropdown, Table, Input } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Test, UserTestAssignment } from "../../stores/TestsStore";
import { useStore } from "../../stores/root-store-context";
import { TestRow } from "./TestUsersInfo";

interface TestSelectProps {
    userTestAssignment: UserTestAssignment;
    allTests: Test[];
    handleUpdateTestPlan: (testId: number, field: keyof UserTestAssignment, value: any) => void;
}

export const TestSelect: React.FC<TestSelectProps> = ({ userTestAssignment, allTests, handleUpdateTestPlan }) => {
    const [searchText, setSearchText] = useState<string>("");
    const [filteredTests, setFilteredTests] = useState<Test[]>(allTests);
    const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);
    const { applicationStore } = useStore();

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.toLowerCase();
        setSearchText(value);
        setFilteredTests(allTests.filter((t) => t.name?.toLowerCase().includes(value)));
    };

    const handleSelectTest = (testId: number) => {
        const selectedTest = allTests.find((test) => test.id === testId);

        if (selectedTest) {
            handleUpdateTestPlan(userTestAssignment.id, "test", selectedTest); 
        }
        
        handleUpdateTestPlan(userTestAssignment.id, "testId", testId);
        setDropdownVisible(false);
    };

    const columns = [
        {
            title: "Уровень",
            dataIndex: "level",
            key: "level",
            sorter: (a: TestRow, b: TestRow) => a.level.localeCompare(b.level),
        },
        {
            title: "Скилл",
            dataIndex: "skill",
            key: "skill",
            sorter: (a: TestRow, b: TestRow) => a.skill.localeCompare(b.skill),
        },
    ];

    const testData: TestRow[] = filteredTests.map((testOption) => ({
        key: testOption.id,
        level: testOption.level || "Не указан",
        skill: applicationStore.skills.find((s) => s.skillId == testOption.skillId?.toString())?.title || "Не указан",
        id: testOption.id,
        name: testOption.name || "Не указан",
    }));

    return (
        <Form.Item style={{ marginBottom: "12px" }}>
            <Dropdown
                trigger={["click"]}
                open={dropdownVisible}
                onOpenChange={setDropdownVisible}
                overlay={
                    <div
                        style={{
                            padding: "10px",
                            background: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                            width: "350px",
                            maxHeight: "350px",
                            overflowY: "auto",
                            border: "1px solid #d9d9d9",
                        }}
                    >
                        <Input
                            placeholder="Поиск теста..."
                            value={searchText}
                            onChange={handleSearch}
                            style={{ marginBottom: "8px" }}
                        />
                        <Table
                            columns={columns}
                            dataSource={testData}
                            pagination={false}
                            rowClassName={(record) =>
                                record.id == userTestAssignment.test?.id ? "selected-row" : ""
                            }
                            onRow={(record) => ({
                                onClick: () => handleSelectTest(record.id),
                                style: { cursor: "pointer" },
                            })}
                            bordered
                        />
                        <style>{`
                            .ant-table-thead > tr > th {
                                background: #f5f5f5 !important;
                                font-weight: bold;
                                text-align: center;
                            }
                            .ant-table-tbody > tr:hover {
                                background: #f0faff !important;
                            }
                            .selected-row {
                                background: #d6f5d6 !important;
                            }
                        `}</style>
                    </div>
                }
            >
                <div
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                    style={{
                        cursor: "pointer",
                        padding: "8px",
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "#fff",
                    }}
                >
                    {userTestAssignment.test ? `${applicationStore.skills.find(s => s.skillId == userTestAssignment.test?.skillId?.toString())?.title} - ${userTestAssignment.test.level}` : "Выберите тест"} <DownOutlined />
                </div>
            </Dropdown>
        </Form.Item>
    );
};
